<script lang="ts">
    import { onMount } from 'svelte';
    import { PAGE_CLUSTER, getPageCluster } from '@shared/domain/PageCluster.ts';
    import { wishlistQualified } from '@tilelist/domain/feature-visibility/WishlistElement.ts';

    interface Props {
        variationId: string;
        multipleSizes?: boolean;
    }

    let { variationId, multipleSizes }: Props = $props();
    const qualified = $derived(wishlistQualified(multipleSizes));

    let source = $state<'SearchResultPage' | 'ProductList' | undefined>(undefined);

    onMount(() => {
        const pageCluster = getPageCluster();
        /*                                                           */
        /*                                                                                      */
        source = pageCluster === PAGE_CLUSTER.PRODUCT_LIST ? 'ProductList' : 'SearchResultPage';
    });
</script>

{#if source}
    <div class="reptile-wishlist-icon">
        <ofc-wishlist-save-button-v1 variation-id={variationId} {qualified} {source}></ofc-wishlist-save-button-v1>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-wishlist-icon {
        /*                                                                                */
        /*                                                                           */
        /*                                                                                    */
        pointer-events: auto;

        position: absolute;
        z-index: 1;
        top: tokens.$oc-semantic-spacing-absolute-25;
        right: tokens.$oc-semantic-spacing-absolute-25;
    }
</style>
